// extracted by mini-css-extract-plugin
module.exports = {"header":"_28b4ab54","searchTerm":"_6a5bd68b"};